import { render, staticRenderFns } from "./InsightsToday.vue?vue&type=template&id=3930791d&scoped=true"
import script from "./InsightsToday.vue?vue&type=script&lang=js"
export * from "./InsightsToday.vue?vue&type=script&lang=js"
import style0 from "./InsightsToday.vue?vue&type=style&index=0&id=3930791d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930791d",
  null
  
)

export default component.exports